"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
/**
 * @params EpisodicItems with custom_sort_index copied over from the ChangeEpisodicItem
 */
function changeEpisodicItemCustomSort(a, b) {
    var check = utils_1.nullCheck(a.custom_sort_index, b.custom_sort_index);
    if (!!check) {
        return check;
    }
    else if (check === null) {
        // both are set
        return utils_1.numberCompare(a.custom_sort_index, b.custom_sort_index);
    }
    else {
        // neither has a custom sort index
        return utils_1.strcasecmp(a.name, b.name);
    }
}
exports.changeEpisodicItemCustomSort = changeEpisodicItemCustomSort;
